export default __webpack_public_path__ + "static/media/placeholder_business06-jp-web.c2af4960.png";